/**
 * Google Maps browser API key resolution for BO Places (#562).
 * Staging Netlify BO historically lacked REACT_APP_GOOGLE_MAPS_API_KEY while
 * dog booking / BO prod had it → AddressAutocomplete « Suggestions indisponibles ».
 *
 * Browser keys are public (HTTP referrer restricted). Fallback matches the key
 * already used by dog staging + API Chalice configs in-repo.
 */

/** Same public browser key as dog-reservation staging / API GOOGLE_MAPS_API_KEY. */
export const DEFAULT_GOOGLE_MAPS_BROWSER_API_KEY =
  'AIzaSyBBazrrdN7yNhsYfmETMe9_5RHk-c56HRQ';

const PLACEHOLDER_KEYS = new Set([
  '',
  'undefined',
  'null',
  'your_google_maps_api_key_here',
]);

/** Strip whitespace + optional surrounding single/double quotes from env values. */
export function normalizeGoogleMapsApiKey(raw: string | undefined | null): string {
  let v = (raw ?? '').trim();
  if (
    (v.startsWith("'") && v.endsWith("'")) ||
    (v.startsWith('"') && v.endsWith('"'))
  ) {
    v = v.slice(1, -1).trim();
  }
  return v;
}

export function hasValidGoogleMapsApiKey(key: string): boolean {
  const normalized = normalizeGoogleMapsApiKey(key);
  return normalized.length > 0 && !PLACEHOLDER_KEYS.has(normalized);
}

/**
 * Resolve usable Maps browser key: env (normalized) or shared public fallback.
 */
export function resolveGoogleMapsApiKey(
  raw: string | undefined | null = process.env.REACT_APP_GOOGLE_MAPS_API_KEY
): string {
  const normalized = normalizeGoogleMapsApiKey(raw);
  if (hasValidGoogleMapsApiKey(normalized)) {
    return normalized;
  }
  return DEFAULT_GOOGLE_MAPS_BROWSER_API_KEY;
}
